/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			this.parent = this.closest('.product-recommendations--parent');

			if (this.classList.contains('cart-recommendations')) {
				this.cart = true;
				this.parent = this.closest('.cart-recommendations--parent');
			}
		}
		fetchProducts() {
			return fetch(this.dataset.url)
				.then(response => {
					if (!response.ok) throw new Error('Unable to load product recommendations');
					return response.text();
				})
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						if (this.parent) {
							if (this.cart) {
								this.parent.classList.add('cart-recommendations--full');
							} else {
								this.parent.classList.add('product-recommendations--full');
							}
						}
						this.querySelectorAll('.lazyload').forEach((image) => {
							lazySizes.loader.unveil(image);
						});
					}

					this.classList.add('product-recommendations--loaded');
					return true;

				})
				.catch(e => {
					console.error(e);
					return false;
				});
		}

		connectedCallback() {
		  if (!this.hasAttribute('data-defer-until-visible')) {
		    this.fetchProducts();
		    return;
		  }
		  if (this.deferredLoading || this.deferredLoaded) return;

		  // The element is hidden until loaded; observe its visible section wrapper.
		  const target = this.closest('.shopify-section') || this.parentElement;
		  if (!('IntersectionObserver' in window) || !target) {
		    this.loadDeferredProducts();
		    return;
		  }
		  this.visibilityObserver?.disconnect();
		  this.visibilityObserver = new IntersectionObserver((entries) => {
		    if (!this.isConnected || !entries.some(entry => entry.isIntersecting)) return;
		    this.visibilityObserver.disconnect();
		    this.loadDeferredProducts();
		  }, { rootMargin: '400px 0px' });
		  this.visibilityObserver.observe(target);
		}

		disconnectedCallback() {
		  this.visibilityObserver?.disconnect();
		}

		loadDeferredProducts() {
		  if (this.deferredLoading || this.deferredLoaded) return;
		  this.deferredLoading = true;
		  this.fetchProducts()
		    .then(success => { this.deferredLoaded = success; })
		    .finally(() => { this.deferredLoading = false; });
		}

	}

	customElements.define('product-recommendations', ProductRecommendations);
}
